<template>
  <div>
    <van-notice-bar v-show="last.availablePayments.length>1 && selectedAmount && payments.length > 1" wrapable left-icon="info-o">
      您正在申请开具<strong class="warn">一张</strong>金额为{{selectedAmount}}元的发票, 如需分开开具, 请分次提交。
    </van-notice-bar>
    <div class="group-title">基本信息</div>
    <van-form @submit="onSubmit">
      <van-cell title="开票金额" is-link @click="actionSheet=true">
        <span><strong style="font-size: 20px; color:black">{{selectedAmount}}</strong> 元<span style="margin-left:30px">修改金额</span></span>
      </van-cell>
      <van-field readonly clickable name="receiptType" :value="receipt.receiptType | typeName" label="发票类型" @click="showTypeSelector = true" is-link/>
      <van-field v-model="receipt.email" name="email" label="电子邮箱" maxlength="35" placeholder="用于接收电子发票" :rules="[{required: true, message: '请输入接收电子发票的邮箱' }]"/>
      
      <div class="group-title">联系方式</div>
      <van-field v-model="receipt.name" name="name" label="姓名" maxlength="20" placeholder="您的个人姓名" :rules="[{required: true, message: '请输入您的个人姓名' }]"/>
      <van-field v-model="receipt.tel" name="tel" label="手机号" maxlength="11" type="tel" placeholder="请输入您的手机号" :rules="[{pattern: /^1\d{10}/, required: true, message: '请输入您的手机号' }]"/>
      <div class="group-title">开票信息</div>
      <van-field v-model="receipt.title" name="title" label="发票抬头" maxlength="40" placeholder="个人或单位名称" :rules="[{required: true, message: '此项必填' }]"/>
      <van-field v-model="receipt.comNum" name="comNum" label="公司税号" maxlength="30" placeholder="社会信用代码或纳税人识别号" :rules="[{required: true, message: '此项必填' }]"/>
      <van-field v-if="receipt.receiptType=='SPECIAL'" v-model="receipt.comBank" name="comBank" label="银行账户" maxlength="25" placeholder="公司的银行账户号码" :rules="[{required: receipt.receiptType=='SPECIAL', message: '此项必填' }]"/>
      <van-field v-if="receipt.receiptType=='SPECIAL'" v-model="receipt.comAccount" name="comAccount" label="开户行" maxlength="25" placeholder="公司的银行账户的开户行" :rules="[{required: receipt.receiptType=='SPECIAL', message: '此项必填' }]"/>
      <van-field v-if="receipt.receiptType=='SPECIAL'" v-model="receipt.comAddress" name="comAddress" label="公司地址" maxlength="110" placeholder="公司注册地址" :rules="[{required: receipt.receiptType=='SPECIAL', message: '此项必填' }]"/>
      <van-field v-if="receipt.receiptType=='SPECIAL'" v-model="receipt.comTel" name="comTel" label="公司电话" maxlength="20" placeholder="公司的银行账户号码" :rules="[{required: receipt.receiptType=='SPECIAL', message: '此项必填' }]"/>
      
      <div class="group-title"></div>
      <van-field v-model="receipt.remark" name="remark" label="备注" maxlength="150" placeholder="选填"/>

      <div style="margin: 16px;">
        <van-button round block type="primary" native-type="submit" :disabled="!loading && !selectedAmount">提交</van-button>
      </div>
    </van-form>

    <div class="recipt-tips">
      <h5>&nbsp;&nbsp;说明: </h5>
      <ul>
        <li>为响应相关政策要求，即日起将仅支持电子发票;</li>
        <li>发票一经确认开出后, 将<strong>不可修改或重新开具</strong>, 请您在提交前确保开票信息无误;</li>
        <li>所填资料仅供开票使用,我们将严格保护您的个人信息.</li>
      </ul>
      <br />
    </div>

    <van-action-sheet v-model="actionSheet" title="请从消费记录中选择金额">
      <div class="action-sheet-content">
        <div class="action-sheet-head">
          <div class="selected-amount">
            <span>已选择开票金额:</span> 
            <strong> {{selectedAmount}}</strong> 元
          </div>
          <van-notice-bar left-icon="info-o">部分不支持在线开票的消费记录未列出 <a href="javascript:;" @click="tips">原因&gt;&gt;</a></van-notice-bar>
          
        </div>
        <div v-if="!last.availablePayments.length">
          <br />
          <van-empty image="search" description="没有可开票的消费记录" />
        </div>
        <van-checkbox-group v-else v-model="payments" class="payment-list">
          <van-cell-group>
            <van-cell v-for="(item, index) in last.availablePayments" clickable :key="item.id" @click="toggle(index)" >
              <template #right-icon>
                <van-checkbox :name="item" ref="checkboxes" />
              </template>
              <template #title class="finance">
                <simple-finance :finance="item"/>
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </div>
    </van-action-sheet>
    <van-popup v-model="showTypeSelector" position="bottom">
      <van-picker show-toolbar :columns="types" @confirm="onTypePickerConfirm" @cancel="showPicker = false" />
    </van-popup>
    <van-popup v-model="showParkingLotSelector" position="bottom">
      <van-picker show-toolbar :columns="parkingLots" @confirm="onParkingLotConfirm" @cancel="showParkingLotSelector = false" />
    </van-popup>
  </div>
</template>
<script>
import {  ActionSheet, Button, Cell, CellGroup, Checkbox, CheckboxGroup, Dialog, Empty, Field, Form, Image, Loading, NoticeBar, Overlay, Picker, Popup, Radio, RadioGroup, Tag} from 'vant';
import SimpleFinanceVue from '../components/SimpleFinance.vue';
import { router } from '../router';

const typeMap = {
  NORMAL : '增值税普通电子发票',
  SPECIAL : '增值税专用电子发票'
}

export default {
  components: {
    [Button.name] : Button,
    [Empty.name] : Empty,
    [Tag.name] : Tag,
    [CellGroup.name] : CellGroup,
    [Cell.name] : Cell,
    [Image.name] : Image,
    [Form.name] : Form,
    [Field.name] : Field,
    [ActionSheet.name] : ActionSheet,
    [Checkbox.name] : Checkbox,
    [Loading.name] : Loading,
    [Overlay.name] : Overlay,
    [Cell.name] : Cell,
    [NoticeBar.name] : NoticeBar,
    [CheckboxGroup.name] : CheckboxGroup,
    [Checkbox.name] : Checkbox,
    [Popup.name] : Popup,
    [Picker.name] : Picker,
    [RadioGroup.name] : RadioGroup,
    [Radio.name] : Radio,
    'simple-finance' : SimpleFinanceVue
  },
  data() {
    return {
      showTypeSelector: false,
      showParkingLotSelector: false,
      loading : false,
      actionSheet : false,
      last: {
        availablePayments: []
      },
      payments : [],
      parkingLots: [],
      amount: 0,
      receipt : {
        receiptType: 'E_NORMAL',
        byMail: false
      }
    };
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  mounted(){
    this.loadStage();
    this.loadParkingLots();
  },
  methods: {
    async onSubmit() {
      try {
        this.loading = true;
        await this.$http.post('/receipt', {...this.receipt, payments: this.payments.map(x=>x.id)});
        router.push('invoices');
      } finally {
        this.loading = false;
      }
      
    },
    tips() {
      Dialog.alert({
        message: '由于部分场地与我们的合作模式仅为代收费, 您在这些停车场的消费发票由停车场方提供, 请直接联系停车场工作人员索取'
      });
    },
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    onTypePickerConfirm(item) {
      this.receipt.receiptType = item.value
      this.showTypeSelector = false;
    },
    onParkingLotConfirm(park) {
      this.receipt.parkingLotId = park.value;
      this.showParkingLotSelector = false;
    },
    async loadStage() {
      try{
        const data = await this.$http.get('/receipt/last');
        this.last = data;
        if (data.availablePayments.length > 0) {
          this.payments = [data.availablePayments[0]]
        }
        this.receipt = {...this.receipt, ...{
          byMail : data.byMail,
          email: data.email,
          name : data.lastName,
          tel : data.lastTel,
          address : data.lastAddress,
          title : data.title,
          comNum : data.lastComNum,
          comAccount : data.lastComAccount,
          comBank : data.lastComBank,
          comAddress : data.lastComAddress,
          comTel : data.lastComTel,
          receiptType : data.receiptType,
          parkingLotId : data.lastParkingLotId
        }}
      } finally {
        this.loading = false;
      }
    },
    async loadParkingLots(){
      try{
        const list = await this.$http.get('/receipt/recent_parking_lot');
        this.parkingLots = list.map(x => ({text : x.value, value: x.key}));
        if (this.parkingLots.length) {
          this.receipt.parkingLotId = this.parkingLots[0].value;
        }
      } finally {
        this.loading = false;
      }
    },
    parkingLotName(parkingLotId) {
      return (this.parkingLots.find(x => x.value == parkingLotId) || {}).text;
    }
  },
  filters: {
    typeName(value) {
      return typeMap[value];
    }
    
  },
  computed: {
    selectedAmount() {
      // 注意避免小数精度问题
      return this.payments.map(x=>x.fee*100).reduce((a,b)=>a+b, 0)/100;
    },
    types() {
      return Object.keys(typeMap).map(key => ({text: typeMap[key], value:  key}));
    }
  }
};
</script>

<style lang="less" scoped>
  .action-sheet-head {
    position: absolute;
    z-index: 2005;
    width: 100%;
    margin-top: 0;
    background-color: white;
    height: 60px;
  }
  .selected-amount {
    padding: 5px 0 5px 15px ;
    background-color: white;
    strong {
      font-size: 24px;
      color: red;
    }
  }
  .payment-list {
    padding-top: 75px;
  }
  .finance {
    margin-right: 10px;
  }
  .group-title{
    font-size: 14px;
    color: gray;
    margin: 10px 0 5px 10px;
  }
  .recipt-tips{
    padding:0 10px;
}
.recipt-tips h5{
    color: #808080;
    margin: 0
}
.recipt-tips ul{
    color: gray;
    font-size: 0.8em;
    line-height: 1.5em
}

.recipt-tips strong {
    color: black;
    font-weight: normal;
}
.recipt-tips li{
    margin-left: 0
}

.dialog-tips {
    padding: 2em 0;
    text-align: center;
}
</style>